class EnJoinNow extends HTMLElement {
  constructor() {
    super();
    this.initialized = false;
  }

  connectedCallback() {
    if (this.initialized) return;
    this.initialized = true;

    // Wait for DOM to fully load
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.init());
    } else {
      this.init();
    }
  }

  init() {
    this.setupMembershipButtons();
    this.setupJoinNowButton();
  }

  setupMembershipButtons() {
    const membershipButtons = document.querySelectorAll('.membership-button');
    
    membershipButtons.forEach(button => {
      button.addEventListener('click', () => {
        // Remove active class from all buttons
        membershipButtons.forEach(btn => {
          btn.classList.remove('membership-button-active');
        });
        
        // Add active class to clicked button
        button.classList.add('membership-button-active');
      });
    });
  }

  setupJoinNowButton() {
    const joinNowButton = document.querySelector('.join-now-btn');
    
    if (!joinNowButton) return;

    joinNowButton.addEventListener('click', (event) => {
      event.preventDefault();
      
      // Get the active membership button
      const activeButton = document.querySelector('.membership-button-active');
      
      if (!activeButton) {
        console.error('No membership option selected');
        return;
      }

      // Add loading state to the button
      joinNowButton.classList.add('is-loading');
      
      // Get product data from active button attributes
      const variantId = activeButton.getAttribute('data-variant-id');
      const sellingPlanId = activeButton.getAttribute('data-selling-plan');
      const entries = activeButton.getAttribute('data-entry');
      const giveaway = activeButton.getAttribute('data-giveaway');
      
      if (!variantId) {
        console.error('No variant ID found');
        joinNowButton.classList.remove('is-loading');
        return;
      }
      
      // Create cart data object
      let formData = {
        'items': [{
          'id': variantId,
          'quantity': 1,
          'properties': {}
        }]
      };
      
      // Add properties if they exist
      if (entries && entries !== 'null' && entries !== 'undefined') {
        const propertyName = window.theme?.entries?.giveaway_name || 'Entries';
        let entriesValue = entries;
        const tierMultiplier = parseInt(window.theme?.entries?.customer_tier_multiplier, 10);
        if (!Number.isNaN(tierMultiplier) && tierMultiplier > 1) {
          const base = parseInt(String(entries).replace(/,/g, ''), 10);
          if (!Number.isNaN(base)) entriesValue = String(base * tierMultiplier);
        }
        formData.items[0].properties[propertyName] = entriesValue;
      }
      
      // Add giveaway property if it exists
      if (giveaway && giveaway !== 'null' && giveaway !== 'undefined') {
        formData.items[0].properties['Giveaway'] = giveaway;
      }
      
      // Add selling plan if it exists (for subscription products)
      if (sellingPlanId && sellingPlanId !== 'null' && sellingPlanId !== 'undefined') {
        formData.items[0].selling_plan = sellingPlanId;
      }
      
      // Add to cart and redirect to cart page
      this.addToCart(formData, joinNowButton);
    });
  }

  addToCart(formData, button) {
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    })
    .then(async response => {
      if (response.ok) {
        if (typeof window.syncCartEntries === 'function') {
          await window.syncCartEntries();
        }

        // Dispatch an event for successful cart addition
        const event = new CustomEvent('en-join-now:product-added', {
          bubbles: true,
          detail: { formData }
        });
        this.dispatchEvent(event);

        // Redirect to cart page
        window.location.href = '/cart';
      } else {
        // Handle error response
        return response.json().then(data => {
          throw new Error(data.description || 'Could not add product to cart');
        });
      }
    })
    .catch(error => {
      console.error('Error adding product to cart:', error);
      button.classList.remove('is-loading');
      alert(error.message || 'Could not add product to cart. Please try again.');
    });
  }

  disconnectedCallback() {
    // Clean up if needed when component is removed
  }
}

// Register the custom element
customElements.define('en-join-now', EnJoinNow);
